// FILE: src/services/courseInfo.js
// WP-6 endpoints: public help centre, glossary, legal documents, contact
// details and accommodation requests (no sign-in), plus the signed-in
// onboarding gates and the end-of-course survey. Every call goes through
// apiFetch/fetchWithAuth (AD-8); failures reject with the server body so
// pages can use errorMessage().
import { apiFetch } from "./api";
import fetchWithAuth from "../utils/fetchWithAuth";

async function publicGet(path) {
  const res = await apiFetch(path);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(body.code || "NETWORK"), { code: body.code || "NETWORK", body });
  return body;
}

export const getHelp = () => publicGet("/api/public/help");
export const getHelpArticle = (id) => publicGet(`/api/public/help/${encodeURIComponent(id)}`);
export const getGlossary = () => publicGet("/api/public/glossary");
export const getLegal = (type) => publicGet(`/api/public/legal/${encodeURIComponent(type)}`);
export const getPublicInfo = () => publicGet("/api/public/info");

export async function requestAccommodation(body) {
  const res = await apiFetch("/api/public/accommodation", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.code || "NETWORK"), { code: data.code || "NETWORK", body: data });
  return data;
}

export const getOnboarding = () => fetchWithAuth("/api/onboarding");
export const completeTutorial = () => fetchWithAuth("/api/onboarding/tutorial-complete", { method: "POST", body: "{}" });
export const acknowledgeDocument = (type, version) =>
  fetchWithAuth("/api/onboarding/acknowledge", { method: "POST", body: JSON.stringify({ type, version }) });

export const getSurveyStatus = () => fetchWithAuth("/api/feedback/status");
export const submitSurvey = (body) => fetchWithAuth("/api/feedback", { method: "POST", body: JSON.stringify(body) });
